// The measurables recorded at camp stations, grouped the way the station and roster screens show them.
// `value` is the stat_name the athlete endpoints (update-stat / verify) take.
export const STAT_OPTIONS = [
  { group: 'Body', stats: [
    { value: 'height_inches', label: 'Height (inches)' },
    { value: 'weight_lbs', label: 'Weight (lbs)' },
    { value: 'wingspan', label: 'Wingspan (inches)' },
    { value: 'hand_size', label: 'Hand Size (inches)' },
  ]},
  { group: 'Performance', stats: [
    { value: 'dash_40', label: '40yd Dash (sec)' },
    { value: 'run_10', label: '10yd Split (sec)' },
    { value: 'run_20', label: 'Flying 10 (sec)' },
    { value: 'short_shuttle', label: 'Short Shuttle (sec)' },
    { value: 'three_cone_drill', label: '3-Cone Drill (sec)' },
    { value: 'broad_jump', label: 'Broad Jump (inches)' },
    { value: 'vertical_jump', label: 'Vertical Jump (inches)' },
  ]},
  { group: 'Strength', stats: [
    { value: 'bench_press', label: 'Bench Press (lbs)' },
    { value: 'squat', label: 'Squat (lbs)' },
    { value: 'clean', label: 'Clean (lbs)' },
    { value: 'deadlift', label: 'Deadlift (lbs)' },
  ]},
];

// Headings the roster grid uses for those groups.
export const SECTION_TITLES = { Body: 'ANTHROPOMETRICS', Performance: 'TESTING', Strength: 'STRENGTH' };

export const ALL_STATS = STAT_OPTIONS.flatMap((g) => g.stats);
